module.exports = __webpack_public_path__ + "static/security-character-28ff5655e5742b5d348741e92a611934.png";